 
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import api from "../api/Api";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  AreaChart,
  XAxis,
  YAxis,
  Area,
  Legend,
} from "recharts";
import logo from '../assets/img/logo.png';

 
const ChamadasPDFRealGraficos = () => {
  const location = useLocation();
  const [resumoFilas, setResumoFilas] = useState([]);
  const [registrosFila, setRegistrosFila] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const relatorioRef = useRef();

  const CORES = {
    ATENDIDA: "#52c41a",
    ABANDONADA: "#fa8c16",
    NAO_ATENDIDA: "#ff4d4f",
    TOTAL: "#1890ff",
  };

  useEffect(() => {
    const carregarDados = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const dataInicio = searchParams.get("dataInicio");
        const dataFim = searchParams.get("dataFim");

        const payload = { dataInicio, dataFim };

        const [resumoResponse, registrosResponse] = await Promise.all([
          api.ListResumoFila(payload),
          api.ListRegistoFila(payload),
        ]);

        setResumoFilas(resumoResponse || []);
        setRegistrosFila(registrosResponse || []);
      } catch (error) {
        console.error(error);
        setErro("Erro ao carregar dados para o PDF.");
      } finally {
        setLoading(false);
      }
    };
    carregarDados();
  }, [location]);

  
  
useEffect(() => {
  if (resumoFilas.length > 0 && registrosFila.length > 0) {
    // Espera o render completo dos gráficos antes de gerar o PDF
    const timeout = setTimeout(() => {
      gerarPDF();
    }, 1200);
    return () => clearTimeout(timeout);
  }
}, [resumoFilas, registrosFila]);




  const processarDadosPizza = (fila) => [
    { name: "Atendidas", value: parseInt(fila.total_atendidas), color: CORES.ATENDIDA },
    { name: "Abandonadas", value: parseInt(fila.total_abandonadas), color: CORES.ABANDONADA },
    { name: "Não Atendidas", value: parseInt(fila.total_nao_atendidas), color: CORES.NAO_ATENDIDA },
  ];

  
  const gerarPDF = async () => {
  const doc = new jsPDF("p", "mm", "a4");
  const larguraPagina = doc.internal.pageSize.getWidth();

  // Cabeçalho da primeira página
  doc.setFontSize(18);
  doc.text("Relatório de Chamadas com Gráficos", larguraPagina / 2, 20, { align: "center" });

  // Logo no canto superior direito
  const logoImg = new Image();
  logoImg.src = logo;
  const logoLargura = 25; // tamanho do logo
  const logoAltura = 25;
  const logoX = larguraPagina - logoLargura - 15; // margem direita
  const logoY = 10; // margem superior
  doc.addImage(logoImg, "PNG", logoX, logoY, logoLargura, logoAltura);

  doc.setFontSize(11);
  const searchParams = new URLSearchParams(location.search);
  doc.text(
    `Período: ${dayjs(searchParams.get("dataInicio")).format("DD/MM/YYYY")} - ${dayjs(searchParams.get("dataFim")).format("DD/MM/YYYY")}`,
    15,
    30
  );
  doc.text(`Gerado em: ${dayjs().format("DD/MM/YYYY HH:mm")}`, 15, 37);

  // Captura de cada fila separadamente
  const filaElements = document.querySelectorAll(".fila-section");

  for (let i = 0; i < filaElements.length; i++) {
    const element = filaElements[i];
    const canvas = await html2canvas(element, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL("image/png");

    const imgWidth = 190;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const position = 50;

    if (i > 0) {
      doc.addPage();

      // Adiciona o logo novamente no topo de cada página nova
      doc.addImage(logoImg, "PNG", logoX, logoY, logoLargura, logoAltura);

      // Adiciona também o título e o período no topo da nova página
      doc.setFontSize(18);
      doc.text("Relatório de Chamadas com Gráficos", larguraPagina / 2, 20, { align: "center" });
      doc.setFontSize(11);
      doc.text(
        `Período: ${dayjs(searchParams.get("dataInicio")).format("DD/MM/YYYY")} - ${dayjs(searchParams.get("dataFim")).format("DD/MM/YYYY")}`,
        15,
        30
      );
      doc.text(`Gerado em: ${dayjs().format("DD/MM/YYYY HH:mm")}`, 15, 37);
    }

    // Adiciona a imagem da fila
    doc.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
  }

  // Nome do arquivo
  const nomeArquivo = `relatorio_chamadas_graficos_${dayjs().format("YYYY-MM-DD_HH-mm")}.pdf`;

  // Faz o download
  doc.save(nomeArquivo);

  // Espera mais tempo proporcional à quantidade de filas (render pesado)
  const tempoEspera = Math.max(3000, filaElements.length * 2000);

  setTimeout(() => {
    window.close();
  }, tempoEspera);
};


  if (loading)
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <h3>Gerando relatório PDF...</h3>
      </div>
    );

  if (erro)
    return (
      <div style={{ padding: 40, color: "red", textAlign: "center" }}>
        <h3>{erro}</h3>
      </div>
    );
return (
  <div
    ref={relatorioRef}
    style={{ padding: 40, background: "#fff", width: "210mm", minHeight: "297mm" }}
  >
    {resumoFilas.map((fila, i) => {
      // Filtra os registros da fila atual
      const registrosDaFila = registrosFila.filter(r => r.fila === fila.fila);

      // Agrupa por dia
      const dadosAgrupados = {};
      registrosDaFila.forEach((r) => {
        const dia = dayjs(r.data).format("DD/MM");
        if (!dadosAgrupados[dia]) {
          dadosAgrupados[dia] = { dia, Completada: 0, Sem_Resposta: 0, Abandonada: 0 };
        }
        if (r.status === "completed") dadosAgrupados[dia].Completada++;
        if (r.status === "no_answer") dadosAgrupados[dia].Sem_Resposta++;
        if (r.status === "abandoned") dadosAgrupados[dia].Abandonada++;
      });

      const dadosChart = Object.values(dadosAgrupados);

      const areasConfig = {
        Completada: { color: "#52c41a", stroke: "#52c41a", gradientId: `gradComp${i}` },
        Sem_Resposta: { color: "#ff4d4f", stroke: "#ff4d4f", gradientId: `gradNoAns${i}` },
        Abandonada: { color: "#fa8c16", stroke: "#fa8c16", gradientId: `gradAban${i}` },
      };

      return (
        <div key={i} className="fila-section" style={{ marginBottom: 80 }}>
          <h2 style={{ color: "#1a3353", marginBottom: 30 }}>Fila: {fila.fila}</h2>

          {/* Parte superior - gráfico + estatísticas */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: 30,
            }}
          >
            {/* Gráfico de Pizza */}
            <div style={{ width: "48%" }}>
              <h3 style={{ textAlign: "center", marginBottom: 10 }}>Distribuição de Chamadas</h3>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={processarDadosPizza(fila)}
                    dataKey="value"
                    cx="50%"
                    cy="50%"
                    outerRadius={120}
                    label
                  >
                    {processarDadosPizza(fila).map((d, idx) => (
                      <Cell key={idx} fill={d.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>

            {/* Estatísticas */}
            <div
              style={{
                width: "48%",
                border: "1px solid #d9d9d9",
                borderRadius: 10,
                padding: 20,
                backgroundColor: "#fafafa",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <h3 style={{ color: "#1a3353", marginBottom: 20, textAlign: "center" }}>
                Estatísticas da Fila
              </h3>
              <table style={{ width: "100%", fontSize: 14, lineHeight: "1.8" }}>
                <tbody>
                  <tr>
                    <td><strong>Total de Chamadas:</strong></td>
                    <td>{fila.total_chamadas}</td>
                  </tr>
                  <tr>
                    <td><strong>Chamadas Atendidas:</strong></td>
                    <td style={{ color: "#52c41a" }}>{fila.total_atendidas}</td>
                  </tr>
                  <tr>
                    <td><strong>Chamadas Não Atendidas:</strong></td>
                    <td style={{ color: "#ff4d4f" }}>{fila.total_nao_atendidas}</td>
                  </tr>
                  <tr>
                    <td><strong>Chamadas Abandonadas:</strong></td>
                    <td style={{ color: "#fa8c16" }}>{fila.total_abandonadas}</td>
                  </tr>
                  <tr>
                    <td><strong>Tempo Médio de Espera:</strong></td>
                    <td>{fila.tempo_medio_espera}</td>
                  </tr>
                  <tr>
                    <td><strong>Duração Média da Chamada:</strong></td>
                    <td>{fila.duracao_media_completed}</td>
                  </tr>
                  <tr>
                    <td><strong>Duração Máxima da Chamada:</strong></td>
                    <td>{fila.duracao_maxima}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Gráfico de Ondas */}
          {dadosChart.length > 0 && (
            <div
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: 10,
                padding: 20,
                backgroundColor: "#fff",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <h3 style={{ textAlign: "center", marginBottom: 20 }}>
                Evolução das Chamadas por Dia
              </h3>

              <ResponsiveContainer width="100%" height={300}>
                <AreaChart
                  data={dadosChart}
                  margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
                >
                  <defs>
                    {Object.entries(areasConfig).map(([key, config]) => (
                      <linearGradient
                        key={config.gradientId}
                        id={config.gradientId}
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop offset="0%" stopColor={config.color} stopOpacity={0.8} />
                        <stop offset="80%" stopColor={config.color} stopOpacity={0.1} />
                      </linearGradient>
                    ))}
                  </defs>

                  <XAxis dataKey="dia" tick={{ fontSize: 12 }} />
                  <YAxis />
                  <Tooltip />
                  <Legend />

                  <Area
                    type="linear"
                    dataKey="Completada"
                    stroke={areasConfig.Completada.stroke}
                    strokeWidth={2}
                    fill={`url(#${areasConfig.Completada.gradientId})`}
                    name="Completadas"
                  />
                  <Area
                    type="linear"
                    dataKey="Sem_Resposta"
                    stroke={areasConfig.Sem_Resposta.stroke}
                    strokeWidth={2}
                    fill={`url(#${areasConfig.Sem_Resposta.gradientId})`}
                    name="Sem Resposta"
                  />
                  <Area
                    type="linear"
                    dataKey="Abandonada"
                    stroke={areasConfig.Abandonada.stroke}
                    strokeWidth={2}
                    fill={`url(#${areasConfig.Abandonada.gradientId})`}
                    name="Abandonadas"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>
      );
    })}
  </div>
);



};

export default ChamadasPDFRealGraficos;
 